export default __webpack_public_path__ + "static/volunteer-thumbnail-1f1fe6c8b321d32d82a439ca510aca01.jpg";